import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-24076d85"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "installment-item-text" }
const _hoisted_2 = { class: "installment-item-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "installment-item",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleClick(_ctx.installment)))
  }, [
    _createElementVNode("span", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.installment.label), 1)
    ]),
    _createElementVNode("span", null, _toDisplayString(_ctx.amountSpanContent), 1)
  ]))
}